
(function () {
  'use strict';

  var FINISH_HEX = {
    'chrome':                 '#c8c8c8',
    'polished-chrome':        '#cfcfcf',
    'brushed-chrome':         '#a8a8a8',
    'satin-chrome':           '#b5b5b5',
    'silver':                 '#c0c0c0',

    'brass':                  '#b5a642',
    'polished-brass':         '#d4af37',
    'antique-brass':          '#9c7a3c',
    'brushed-brass':          '#b5a76a',
    'satin-brass':            '#b5a76a',
    'aged-brass':             '#8b6f3c',
    'gold':                   '#d4af37',
    'polished-gold':          '#e6c200',
    'matte-gold':             '#b58e1a',
    'rose-gold':              '#b76e79',
    'gold-rose':              '#b76e79',

    'nickel':                 '#a8a8a8',
    'polished-nickel':        '#bcbcbc',
    'brushed-nickel':         '#9a9a9a',
    'satin-nickel':           '#a8a8a8',

    'copper':                 '#b87333',
    'polished-copper':        '#d68740',
    'antique-copper':         '#8b5a2b',
    'brushed-copper':         '#a06642',

    'bronze':                 '#cd7f32',
    'antique-bronze':         '#a87332',
    'oil-rubbed-bronze':      '#3a2818',
    'dark-bronze':            '#2e2018',

    'black':                  '#1a1a1a',
    'matte-black':            '#1a1a1a',
    'satin-black':            '#262626',
    'gloss-black':            '#0d0d0d',
    'white':                  '#f5f5f5',
    'matte-white':            '#f5f5f5',
    'gloss-white':            '#ffffff',
    'off-white':              '#efece5',
    'cream':                  '#f5f0e1',
    'pewter':                 '#8a8a8a',
    'gunmetal':               '#2a3439',
    'graphite':               '#383838',
    'charcoal':               '#36454f',

    'clear':                  '#eef2f5',
    'frosted':                '#e8e8e8',
    'smoke':                  '#3a3a3a',
    'smoked':                 '#3a3a3a',
    'amber':                  '#ffbf00',

    'walnut':                 '#5d4037',
    'oak':                    '#c19a6b',
    'mahogany':               '#4e2728',
    'natural':                '#d2b48c',

    'satin-graphite':         '#333333',
    'matte-graphite':         '#333333',
    'brushed-graphite':       '#3a3a3a',
    'aged-graphite':          '#2f2f2f',
    'dark-graphite':          '#2a2a2a',
    'satin-copper':           '#a56a43',
    'aged-copper':            '#7a4a2b',
    'satin-black':            '#262626',
    'textured-black':         '#1f1f1f',

    'champagne':              '#e6d5a8',
    'champagne-gold':         '#d9c37a',
    'brushed-gold':           '#cbb26b',
    'aged-gold':              '#c0a250',
    'antique-gold':           '#c5a253',
    'burnished-brass':        '#a8894a',
    'weathered-brass':        '#9c8748',
    'matte-brass':            '#a08a3c',
    'heritage-brass':         '#9a7d3f'
  };

  function handleize(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  var colorTester = null;
  function isValidCssColor(str) {
    if (!str) return false;
    if (!colorTester) colorTester = document.createElement('div');
    colorTester.style.color = '';
    colorTester.style.color = str;
    return colorTester.style.color !== '';
  }

  function hasRealBackgroundImage(el) {
    var s = el.getAttribute('style') || '';
    var m = s.match(/background-image\s*:\s*url\(\s*['"]?\s*([^'")\s]+)/i);
    return !!(m && m[1] && m[1].toLowerCase() !== 'none');
  }

  var BLANK_BG = { '': 1, 'white': 1, '#fff': 1, '#ffffff': 1, 'transparent': 1, 'inherit': 1, 'initial': 1, 'rgb(255,255,255)': 1, 'rgba(0,0,0,0)': 1 };
  function hasRealBackgroundColor(el) {
    var s = el.getAttribute('style') || '';
    var m = s.match(/background-color\s*:\s*([^;]+)/i);
    if (!m) return false;
    var val = m[1].trim();
    if (BLANK_BG[val.toLowerCase().replace(/\s+/g, '')]) return false;
    return isValidCssColor(val);
  }

  function pickColor(value) {
    var handle = handleize(value);
    if (!handle) return null;

    if (FINISH_HEX[handle]) return FINISH_HEX[handle];

    if (isValidCssColor(handle)) return handle;

    if (isValidCssColor(value)) return value;

    return null;
  }

  function applyColor(el, color) {

    el.style.setProperty('background-color', color, 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.setAttribute('data-hulk-fallback', 'color');
  }

  function applyTextFallback(el, value) {
    if (el.querySelector('.hulk-swatch-fallback-text')) return;
    var span = document.createElement('span');
    span.className = 'hulk-swatch-fallback-text';
    span.textContent = value;
    el.appendChild(span);
    el.setAttribute('data-hulk-fallback', 'text');
  }

  function patch(el) {
    if (el.__hulkPatched) return;
    el.__hulkPatched = true;


    if (hasRealBackgroundImage(el)) return;
    if (hasRealBackgroundColor(el)) return;

    var value = el.getAttribute('data-conditional-value') || el.getAttribute('value') || '';
    if (!value) return;

    var color = pickColor(value);
    if (color) {
      applyColor(el, color);
      return;
    }

    applyTextFallback(el, value);
  }

  function scan(root) {
    if (root.matches && root.matches('.hulkapps_swatch_option .hulkapps_option_child')) patch(root);
    var swatches = root.querySelectorAll('.hulkapps_swatch_option .hulkapps_option_child');
    for (var i = 0; i < swatches.length; i++) patch(swatches[i]);
  }

  var roots = new Map();
  var markerSelector = '[id^="hulkapps_custom_options_"]';

  function discover(scope) {
    var markers = Array.from(scope.querySelectorAll(markerSelector));
    if (scope.matches && scope.matches(markerSelector)) markers.unshift(scope);
    markers.forEach(function (marker) {
      var root = marker.closest('form') || marker.parentElement;
      if (!root || roots.has(root)) return;
      scan(root);
      var observer = null;
      if ('MutationObserver' in window) {
        observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType === 1 && root.contains(node)) scan(node);
            }
          }
        });
        observer.observe(root, { childList: true, subtree: true });
      }
      roots.set(root, observer);
    });
  }

  function start() {
    discover(document);
    document.addEventListener('shopify:section:load', function (event) {
      discover(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      roots.forEach(function (observer, root) {
        if (event.target.contains(root)) {
          if (observer) observer.disconnect();
          roots.delete(root);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
